import { loadComponent } from '@/helpers/asyncLoaders'
import store from '@/store/store'

import {
  VUEX_USER_HAS_CONFERENCE_ASIAN,
  VUEX_USER_HAS_CONFERENCE_DOMESTIC,
  VUEX_USER_HAS_CONFERENCE_INTERNATIONAL
} from '@/store/constants/user'

const hasPerms = () => {
  return store.getters[VUEX_USER_HAS_CONFERENCE_ASIAN] ||
    store.getters[VUEX_USER_HAS_CONFERENCE_DOMESTIC] ||
    store.getters[VUEX_USER_HAS_CONFERENCE_INTERNATIONAL]
}

export const routes = {
  path: 'spring26',
  name: 'spring26--main',
  meta: {
    conferenceClass: 'fall25'
  },
  component: loadComponent('GlobalConference/Spring26/Main.vue'),
  redirect: { name: 'spring26--landing' },
  children: [
    {
      path: 'load',
      name: 'spring26--load',
      component: loadComponent('GlobalConference/Spring26/Pages/Load.vue')
    },
    {
      path: 'landing',
      name: 'spring26--landing',
      component: loadComponent('GlobalConference/Spring26/Pages/Landing.vue'),
      beforeEnter: (to, from, next) => {
        if (!store.state.globalConference.fall25.loaded) {
          return next({ name: 'spring26--load' })
        }
        next()
      }
    },
    {
      path: 'categories',
      name: 'spring26--categories',
      component: loadComponent('GlobalConference/Spring26/Pages/Categories.vue'),
      meta: {
        eventCategory: 'spring26',
        title: 'Product Categories',
        navigation: [
          'Womens',
          'Mens',
          'Kids',
          'Unisex'
        ]
      }
    },
    {
      path: '',
      name: 'spring26--dashboard',
      component: loadComponent('GlobalConference/Spring26/Dashboard.vue'),
      beforeEnter: (to, from, next) => {
        if (hasPerms()) {
          next()
        } else {
          next('/')
        }
      },
      children: [
        {
          path: '',
          name: 'spring26--dashboard-default',
          redirect: { name: 'spring26--ads' }
        },
        {
          path: 'ads',
          name: 'spring26--ads',
          component: loadComponent('GlobalConference/Spring26/Pages/Advertising.vue'),
          meta: {
            eventCategory: 'spring26',
            title: 'Advertising',
            navigation: [
              'Marketing',
              'Womens',
              'Mens',
              'Kids',
              'Unisex',
              'Work',
              'BTS',
              'International',
              'Performance',
              'Social',
              'Radio',
              'Apparel'
            ]
          }
        },
        {
          path: 'sessions',
          name: 'spring26--sessions',
          component: loadComponent('GlobalConference/Spring26/Pages/Sessions.vue'),
          meta: {
            eventCategory: 'spring26',
            title: 'General Sessions'
          }
        }
      ]
    }
  ]
}

/* export const routes = {
  path: 'fall25',
  name: 'spring26--main',
  meta: {
    conferenceClass: 'fall25'
  },
  component: loadComponent('GlobalConference/Spring26/Main.vue'),
  redirect: { name: 'spring26--dashboard' },
  children: [
    {
      path: 'dashboard',
      name: 'spring26--dashboard',
      component: loadComponent('GlobalConference/Spring26/Dashboard.vue'),
    },

    {
      path: 'categories',
      name: 'spring26--categories',
      component: loadComponent('GlobalConference/Spring26/Pages/Categories.vue'),
      meta: {
        eventCategory: 'spring26',
        title: 'Product Categories',
        navigation: [
          'Womens',
          'Mens',
          'Kids',
          'Unisex'
        ]
      }
    },
  ]
} */
